export default {

    LOAD_SCHEDULED_NOTE(state, scheduled_note) {
        state.items = scheduled_note;
    }

}